import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { CookieManagerTriggerNavLink } from './CookieContext';
import { useAuth } from './auth';

export default function InfoButton () {
    const {user, login, logout} = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  // Track hovered link index
  const [hoveredIdx, setHoveredIdx] = React.useState(null);

  // Menu items
  const menuItems = [
    { label: 'Home', to: '/' },
    ...(user ? [
      { label: 'Account', to: '/settings/account'},
      { label: 'Log Out', to: '/settings/logout'}
    ] : [{ label: 'Log In', to: '/' }]),
    { label: 'Unfinished Future Concepts', to: '/unfinished' },
    { label: 'Privacy Policy', to: '/privacy' },
    { label: 'Terms of Use', to: '/terms' },
    { label: 'Contact', to: '/contact' }

  ];

  // Calculate vertical center for menu
  const buttonTop = 100;
  const buttonHeight = 60;
  const menuHeight = 180; // Approximate, can be adjusted
  const menuTop = `calc(50 - ${menuHeight/2}px)`;

  // Add keyframes for pulsing animation
  React.useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes pulse-bg {
        0% { background: #444; }
        50% { background: #666; }
        100% { background: #444; }
      }
    `;
    document.head.appendChild(style);
    return () => { document.head.removeChild(style); };
  }, []);

  return (
    <>
      <button 
        onClick={() => setOpen(o => !o)}
        style={{ 
          position: 'fixed',
          top: 20,
          right: 10,
          zIndex: 1000,
          width: '60px',
          height: '60px',
          background: open ? undefined : '#253440',
          borderRadius: '50%',
          border: 'none',
          color: '#42bbdd',
          cursor: 'pointer',
          fontSize: '3rem',
          fontWeight: 'bold',
          padding: 0,
          margin: 0,
          fontFamily: 'Arial, sans-serif',
          animation: open ? 'pulse-bg 1.2s infinite' : 'none',
        }}
        aria-label="Open info menu"
      >
        {/* 🛈 */}
        {/* <span style={{position: 'relative', top: -10}}>...</span> */}

      <img src="https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/sweattext_icon_nopad.png" 
        alt="SweatText Banner "
        style={{ width: '100%', maxWidth: 100, marginBottom: 20 }} />
        
      </button>
      {open && (
        <>
          {/* Translucent backdrop */}
          <div
            onClick={() => setOpen(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: 'rgba(0,0,0,0.8)',
              zIndex: 998,
              cursor: 'pointer',
            }}
          />
          {/* Connecting line from button to menu */}
          {/* <div style={{
            position: 'fixed',
            top: 50,
            right: 60,
            width: '60px',
            height: '20px',
            background: '#333',
            zIndex: 998,
            transform: 'translateY(-4px)',
            borderRadius: '4px',
          }} /> */}
          <div style={{
            position: 'fixed',
            top: 20,
            right:10,
            zIndex: 999,
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            background: '#0d1d2b',
            borderRadius: '30px',
            border: '10px solid #555',
            padding: '24px 16px 24px 24px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
            transition: 'right 0.3s',
            minWidth: '180px',
            alignItems: 'flex-start',
            maxHeight: '80vh',
            overflowY: 'auto',
          }}>
            {menuItems.map((item, idx) => (
              <Link
                key={item.to}
                to={item.to}
                style={{
                  color: '#42bbdd',
                  background: hoveredIdx === idx ? '#454' : 'none',
                  border: 'none',
                  fontSize: '1.1rem',
                  textAlign: 'left',
                  padding: '8px 0',
                  cursor: 'pointer',
                  textDecoration: 'none',
                  fontFamily: 'Arial, sans-serif',
                  borderRadius: '8px',
                  transition: 'background 0.2s',
                }}
                onClick={() => {
                    item.action ? item.action() :
                    setOpen(false)}}
                onMouseEnter={() => setHoveredIdx(idx)}
                onMouseLeave={() => setHoveredIdx(null)}
              >
                {item.label}
              </Link>
            ))}
            <span style={{padding: '8px 0',

                background: hoveredIdx === menuItems.length ? '#454' : 'none',
                border: 'none',
                fontSize: '1.1rem',
            }}
            onMouseEnter ={() => setHoveredIdx(menuItems.length)}
            onMouseLeave={() => setHoveredIdx(null)}
            >
              <CookieManagerTriggerNavLink onClick={() => setOpen(false)} />
            </span>
          </div>
        </>
      )}
    </>
  );
};
